/**
 * SPDX-FileCopyrightText: © 2021-2026 SAS Cœur du Web, Paris (France) — https://coeurduweb.com
 * SPDX-License-Identifier: LicenseRef-CoeurDuWeb-Proprietary
 *
 * Tous droits réservés. Logiciel propriétaire, non libre.
 * Les conditions d'utilisation, le périmètre de la licence concédée et les
 * restrictions applicables figurent dans le fichier LICENCE.md à la racine du dépôt.
 */
export default () => ({
    events: null,
    event: null,
    eventsConfig: {
        include: 'author,coverMedia,reactions,comments.citizen',
        sort: 'start_date',
        sortDirection: 'desc',
        page: 1,
        per_page: 25,
        filters: {}
    }
})
